import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import MutationManagementEmployeeRights from "graphql/mutations/management/MutationManagementEmployeeRights";

export default class MutateEmployeeRights {
	
	static log( value ) {
		console.prefix('MutateEmployeeRights', value );
	}
	
	static mutate = ( buildingGuid, floorGuid, roomGuid, employeeGuids, { callbackSuccess = null, callbackError = null, callbackStart = null, table = null, guid = null } = {} ) => {
		
		const builder = new GraphqlBuilder();
		builder.addQuery( 'mutation_employee_rights', MutationManagementEmployeeRights, {
			building_guid: buildingGuid,
			floor_guid: floorGuid,
			room_guid: roomGuid,
			employee_guid: _.isArray( employeeGuids ) ? employeeGuids : [ employeeGuids ]
		})
		
		builder.setOnStart( callbackStart );
		
		builder.setOnSuccess( ( result ) => {
			this.onSuccess( result, callbackSuccess );
		});
		
		builder.setOnError( (result) => {
			this.onSuccess( result, callbackError );
		} );
		
		if( builder.queries.length > 0 ) {
			builder.execute();
			return;
		}

		this.onSuccess( {}, callbackSuccess );
	}

	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onSuccess = ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	}

	/**
	 *
	 * @param result
	 * @param callback
	 */
	static onError = ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	}
}
